import { HeaderProps } from "@/src/layout/header/desktop/v1";
import { menuItemsProps } from "../menu";

export const headerData_ar: HeaderProps = {
  menuItems: menuItemsProps,
  contactInfo: {
    title: "تحتاج مساعدة ؟",
    phone: "785-0100-005(964+)",
  },
};
